<template>

    <div>
        <div>
            <label v-if="label" class="block text-sm leading-5 mb-1.5">
                {{ label }}
            </label>
            <draggable
                class="space-y-2 overflow-auto"
                v-model="fields"
                handle=".handle"
                group="fields"
                @start="drag=true"
                direction="vertical"
                chosenClass="bg-gray-100"
                @end="drag=false"
                item-key="$index"
            >
                <template #item="{element}">
                    <Field :data="element" :program-id="programId" @remove="removeField" />
                </template>
            </draggable>
            <div v-if="!fields.length" class="rounded border flex justify-center text-sm py-4 px-5">{{zeroFieldsMessage}}</div>
        </div>
        <div class="w-max mt-2">
            <options :is-top="true" :is-right="false">
                <template #toggle>
                    <btn type="secondary" icon-name="more" icon-right="true" v-on:click.prevent>Add field</btn>
                </template>
                <template v-slot:items="{ setShow }">
                    <options-item v-if="isNPSubscriptionForm && !isNameIncluded()" @click="addField('np_subscription_name');setShow(false)" title="Name"></options-item>
                    <options-item v-if="(isSignupForm || isSignupPopupForm || isEmbeddableSignupForm) && !isLastnameIncluded()" @click="addField('portal_signup_last_name');setShow(false)" title="Last name"></options-item>
                    <options-item @click="addField('text');setShow(false)" title="Text"></options-item>
                    <options-item @click="addField('input');setShow(false)" title="Input"></options-item>
                    <options-item @click="addField('textarea');setShow(false)" title="Textarea"></options-item>
                    <options-item @click="addField('checkbox');setShow(false)" title="Checkbox"></options-item>
                    <options-item @click="addField('radio');setShow(false)" title="Radio"></options-item>
                    <options-item @click="addField('select');setShow(false)" title="Select"></options-item>
                    <options-item @click="addField('countries');setShow(false)" title="Countries"></options-item>
                    <options-item @click="addField('phone');setShow(false)" title="Phone number"></options-item>
                    <options-item v-if="(isSignupForm || isSignupPopupForm || isEmbeddableSignupForm) && isAffiliateProgram && !hasPartnerTagsField()" @click="addField('partner_tags');setShow(false)" title="Partner tags"></options-item>
                    <options-item v-if="(isSignupForm || isSignupPopupForm || isEmbeddableSignupForm) && !isLinkKeyIncluded()" @click="addField('portal_signup_link_key');setShow(false)" title="Personalized token"></options-item>
                </template>
            </options>
        </div>

        <input type="hidden" :name="name" :value="fieldsString" />

    </div>

</template>

<script>
import draggable from 'vuedraggable'
import Field from './Field.vue'
import {debounce} from "lodash";

export default {
    props: {
        name: {
            type: String,
        },
        modelValue: {
            type: Array,
            default: () => []
        },
        zeroFieldsMessage: {
            type: String,
        },
        formType: {
            type: String,
            default: ''
        },
        programType: {
            type: String,
            default: 'affiliate'
        },
        programId: {
            type: [Number, String],
            default: null
        },
        label: {
            type: String,
            default: ''
        }
    },

    components: {
        Field,
        draggable
    },

    emits: ['update:modelValue'],

    computed: {
        fieldsString() {
            return JSON.stringify(this.fields)
        },
        isSignupForm() {
            return this.formType === 'signup'
        },
        isSignupPopupForm() {
            return this.formType === 'signup_popup'
        },
        isEmbeddableSignupForm() {
            return this.formType === 'embeddable_signup'
        },
        isNPSubscriptionForm() {
            return this.formType === 'np_subscription'
        },
        isAffiliateProgram() {
            return this.programType === 'affiliate'
        }
    },

    data() {
        return {
            fields: [...this.modelValue],
            drag: false,
        }
    },

    watch: {
        modelValue: {
            handler(val) {
                if (JSON.stringify(val) !== JSON.stringify(this.fields)) {
                    this.fields = [...val];
                }
            },
            deep: true,
        },
        fields: {
            handler: debounce(function (val) {
                if (JSON.stringify(val) !== JSON.stringify(this.modelValue)) {
                    this.$emit('update:modelValue', val);
                }
            }, 250), // Adjust delay as needed
            deep: true,
        },
    },

    created() {
        this.fields = this.modelValue || []
    },

    methods: {
        addField(type) {
            let newField = {
                type,
                title: '',
                required: false,
                edit: true
            };

            if (type === 'phone') {
                newField.default_dial_code = '';
                newField.code_selection = 'all';
                newField.selected_codes = [];
            }

            // Initialize partner_tags specific properties
            if (type === 'partner_tags') {
                newField.input_type = 'checkbox';
                newField.tag_selection = 'all';
                newField.selected_tags = [];
            }

            this.fields.push(newField);
        },
        removeField(field) {
            this.fields = this.fields.filter((item) => item !== field)
        },
        isLastnameIncluded() {
            let result = this.fields.filter(field => field.type === 'portal_signup_last_name');
            return result.length;
        },
        isLinkKeyIncluded() {
            let result = this.fields.filter(field => field.type === 'portal_signup_link_key');
            return result.length;
        },
        hasPartnerTagsField() {
            let result = this.fields.filter(field => field.type === 'partner_tags');
            return result.length;
        },
        isNameIncluded() {
            let result = this.fields.filter(field => field.type === 'np_subscription_name');
            return result.length;
        },
    }
}
</script>
